<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [style]="{width: '90vw', height: '90vh', maxWidth: '1400px'}"
  [contentStyle]="{padding: '0', overflow: 'hidden', display: 'flex', flexDirection: 'column'}"
  (onShow)="onShow()"
  (onHide)="onHide()"
  styleClass="mappa-scheda-dialog"
>
<ng-template pTemplate="header">
  <div class="dialog-header" style="padding: 0.5rem; display: flex; align-items: center; justify-content: space-between;">
    <div style="display: flex; align-items: center;">
      <h2 style="font-size: 1.2rem; margin: 0;">Posizione dell'intervento</h2>
      <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
        <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ scheda?.codice }}</span>
      </div>

    </div>
  </div>
</ng-template>
  <div class="mappa-container">
    <div class="map-actions">
     <!--  <button
        pButton
        pTooltip="Zoom sulla geometria selezionata"
        tooltipPosition="bottom"
        icon="pi pi-search"
        [disabled]="!datiGeoJSON"
        (click)="zoomSuScheda()"
        class="p-button-rounded p-button-text">
      </button> -->

      <button
        pButton
        pTooltip="{{opzioniMappa.mostraComuni ? 'Nascondi confini comuni' : 'Mostra confini comuni'}}"
        tooltipPosition="bottom"
        [icon]="opzioniMappa.mostraComuni ? 'pi pi-eye-slash' : 'pi pi-eye'"
        (click)="toggleConfiniComuni()"
        class="p-button-rounded p-button-text">
      </button>
    </div>
    <div #map class="map-container">
      <p-progressSpinner *ngIf="isLoading"
        [style]="{width: '50px', height: '50px'}"
        styleClass="custom-spinner"
        strokeWidth="8"
        fill="var(--surface-ground)"
        animationDuration=".5s">
      </p-progressSpinner>
    </div>
  </div>
</p-dialog>
